import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Client } from 'src/app/interfaces/client';
import { SuperAdminService } from 'src/app/services/api/super-admin.service';

@Component({
  selector: 'app-client-info',
  templateUrl: './client-info.component.html',
  styleUrls: ['./client-info.component.scss']
})
export class ClientInfoComponent implements OnInit {

    @Input() clientID!: string;
    
    public client! : Client;

    public clientUpdateForm!: FormGroup ;

    public errorMessage: string = '';
    public errorType: string = '';

    constructor(private superAdminService: SuperAdminService,
                public activeModal: NgbActiveModal) { }

    ngOnInit(): void {
        this.superAdminService.getClientInfo(this.clientID).subscribe(
            (res) => {
                if (res.result == "SUCCESS") {
                    this.client = res.content;
                    this.clientUpdateForm = new FormGroup({
                        //name: new FormControl(this.client.name, [Validators.required]),
                        referenceNumber: new FormControl(this.client.reference_number),
                        url: new FormControl(this.client.url),
                        directory: new FormControl(this.client.directory),
                        cgu_mml: new FormControl(this.client.cguMml)
                    });
                } else {
                    this.errorMessage = res.content;
                    this.errorType = res.result;
                }
            }, (err) => {
                this.activeModal.dismiss("Delete " + this.clientID);
            }
        );
    }

    updateClient(formValue: any) {
        formValue.id = this.client.id;
        this.superAdminService.updateClient(formValue).subscribe((res) => {
            if (res.result == 'SUCCESS') {
                this.updateClientInfo(formValue);
            }
            this.errorMessage = res.content;
            this.errorType = res.result;
        });
    }

    private updateClientInfo(updatedInfo: any)
    {
        
        if (this.client.reference_number != updatedInfo.referenceNumber) {
            this.client.reference_number = updatedInfo.referenceNumber;
        }

        if (this.client.url != updatedInfo.url) {
            this.client.url = updatedInfo.url;
        }
    }

    public hasError = (controlName: string, errorName: string) => {
        return this.clientUpdateForm?.controls[controlName].hasError(errorName);
    }

}
